import { Box3, Group, Mesh, PlaneBufferGeometry, Vector3 } from "three";
import { mainCamera } from "../../cameras";
import { toggleCursor } from "../../renderer";
import InteractiveObject from "../../utils/interactive-object";
import { createSpacedText, FONT_SEMI_BOLD } from "../../utils/text";

import gsap from "gsap";
import { Quad } from "gsap/gsap-core";
import AmbientMotion from "../../utils/ambient-motion";
import { EventEmitter } from "eventemitter3";

export default class Objkt extends EventEmitter {
  constructor(gui, data, material, hiddenMaterial) {
    super();
    // this.gui = gui.addFolder(`${data.objkt}`);
    // this.gui.open();
    this.data = data;
    this.group = new Group();
    const initialScale = 0.1;
    this.group.scale.set(initialScale, initialScale, initialScale);
    this.textGroup = createSpacedText(
      `OBJKT ${data.objktID}`,
      material,
      0.25,
      FONT_SEMI_BOLD,
      1.5
    );
    this.group.add(this.textGroup);

    const size = new Vector3();
    const center = new Vector3();
    const bbox = new Box3().setFromObject(this.textGroup);
    bbox.getSize(size);
    bbox.getCenter(center);
    const padding = 0.25;
    const hitbox = new Mesh(
      new PlaneBufferGeometry(size.x + padding, size.y + padding),
      hiddenMaterial
    );
    hitbox.position.copy(center);
    hitbox.position.z -= 0.01;

    // this.gui
    //   .add(this.group.scale, "x", 0.1, 5)
    //   .name("scale")
    //   .onChange((val) => {
    //     this.group.scale.set(val, val, val);
    //   });

    this.textGroup.add(hitbox);

    this.textGroup.scale.set(2, 2, 2);

    this.interactiveObject = new InteractiveObject(hitbox, mainCamera, {
      touchStart: true,
      touchMove: true,
      touchEnd: true,
      mouseMove: false,
    });
    this.interactiveObject.on("start", this.onStart);
    this.interactiveObject.on("hover", this.onHover);
    this.interactiveObject.on("end", this.onEnd);

    this.ambientMotion = new AmbientMotion(this.gui);
  }

  animate(delay) {
    gsap.to(this.group.scale, 2, {
      x: 1,
      y: 1,
      z: 1,
      delay,
    });
  }

  onStart = (event) => {
    // const url = `https://www.hicetnunc.xyz/objkt/${this.data.objkt}`;
    // window.open(url, "_blank");
    this.emit("click", this.data.objktID);
  };

  onHover = (over, event) => {
    // console.log(over ? "over" : "out", over ? event : "");
    toggleCursor(over);
    gsap.killTweensOf(this.textGroup);
    gsap.to(this.textGroup.scale, 0.25, {
      x: over ? 2.2 : 2,
      y: over ? 2.2 : 2,
      z: over ? 2.2 : 2,
      ease: Quad.easeOut,
    });
  };

  onEnd = () => {
    // console.log("end");
  };

  update = (delta) => {
    this.ambientMotion.update(delta);
    this.textGroup.position.x = this.ambientMotion.value.x;
    this.textGroup.position.y = this.ambientMotion.value.y;
    this.textGroup.position.z = this.ambientMotion.value.z;
  };
}
